import * as React from 'react';
import { Grid, Typography, Divider, CircularProgress } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { styles } from '../../styles';
import { contactReservationResonse } from '../../../../model/reservation'
import { WithMediaQuery, IMediaQueryProps } from '../../../../layout/withMediaQuery';
import { SortIcon } from '../../../tags/components/Detail/sortIcon';
import clsx from 'clsx';
import { UserPagination } from '../../../chat/component/UserPagination';

interface IProps extends IMediaQueryProps, IInnerProps { }

interface IInnerProps extends StyledComponentProps {
    reservations: contactReservationResonse[];
    loadingReservations: boolean;
    page: number;
    updatePage(neg: number);
    setUserReservationToDelete: (userReservation: contactReservationResonse) => void;
}

const DefaultRowsPerPage = 10;


const Row = (classes, r: contactReservationResonse, n: number, smallScreen: boolean, setUserReservationToDelete: (userReservation: contactReservationResonse) => void) => (
    <Grid style={{ width: "100%" }}><Grid container className={classes.tableRow} onClick={() => setUserReservationToDelete(r)} >
        {!smallScreen && <Grid item sm={1} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{n + 1}</Typography>
        </Grid>}
        <Grid item xs={12} sm={4} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{r.surname} {r.name}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{r.email}</Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{r.tel}</Typography>
        </Grid>
    </Grid>
        <Divider style={{ width: '100%' }} /></Grid>)



const ReservationSlotUserTable = (props: IProps) => {
    const [sortAttribute, setSortAttribute] = React.useState('');
    const [sort, setSort] = React.useState('');
    const sortColumn = (col: string) => {
        const direction = sortAttribute === col ? sort === 'up' ? 'down' : 'up' : 'down';
        setSort(direction);
        setSortAttribute(col);
    }
    const sortData = (followers: contactReservationResonse[]) => {
        followers.sort((c1, c2) => {
            const _1 = c1[sortAttribute] ? c1[sortAttribute].toLowerCase() : '';
            const _2 = c2[sortAttribute] ? c2[sortAttribute].toLowerCase() : '';
            var res = _1 < _2 ? -1 : 1;
            if (sort === 'up')
                res = res * -1;
            return res;
        })
        return followers;
    }
    const { classes, reservations, page } = props;
    return (
        <Grid container>
            {props.loadingReservations ?
                <Grid item sm={12} spacing={2} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress /><Typography component="span" className={classes.Typography}>Aggiornamento Lista</Typography>
                </Grid>
                :
                <div style={{ width: "100%" }}>
                    {!props.smallScreen && <Grid container className={classes.tableHeader}>
                        <Grid item sm={1} className={clsx(props.classes.tableHeaderCell, "first")}>
                            <Typography className={classes.detailHeaderText}>N.</Typography>
                        </Grid>
                        <Grid item sm={4} className={clsx(props.classes.tableHeaderCell, "sort")} onClick={() => sortColumn('surname')}>
                            <Typography className={classes.detailHeaderText}>Cognome e Nome</Typography>
                            <SortIcon sort={sortAttribute === 'surname' ? sort : ''} onClick={() => { }} />
                        </Grid>
                        <Grid item sm={4} className={clsx(props.classes.tableHeaderCell, "sort")} onClick={() => sortColumn('email')} >
                            <Typography className={classes.detailHeaderText}>Email</Typography>
                            <SortIcon sort={sortAttribute === 'email' ? sort : ''} onClick={() => { }} />
                        </Grid>
                        <Grid item sm={3} className={clsx(props.classes.tableHeaderCell, "sort", "last")} onClick={() => sortColumn('tel')}>
                            <Typography className={classes.detailHeaderText}>Telefono</Typography>
                            <SortIcon sort={sortAttribute === 'tel' ? sort : ''} onClick={() => { }} />
                        </Grid>
                    </Grid>}
                    <Grid container className={classes.table}>
                        {reservations && sortData(reservations).slice(page * DefaultRowsPerPage, page * DefaultRowsPerPage + DefaultRowsPerPage)
                            .map((f, idx) => { return Row(classes, f, (page * DefaultRowsPerPage) + idx, props.smallScreen, props.setUserReservationToDelete) })}
                    </Grid>
                    {props.reservations.length > 10 && <UserPagination
                        page={props.page}
                        rowsPerPage={DefaultRowsPerPage}
                        totalRows={props.reservations.length}
                        prev={() => { props.updatePage(props.page - 1) }}
                        next={() => { props.updatePage(props.page + 1) }} />}
                </div>}
        </Grid>

    );

};

export default WithMediaQuery(withStyles(styles as any)(ReservationSlotUserTable)) as React.ComponentType<IInnerProps>
